module.exports = {"420527101":"茅坪镇","420527102":"归州镇","420527103":"屈原镇","420527104":"沙镇溪镇","420527105":"两河口镇","420527106":"郭家坝镇","420527107":"杨林桥镇","420527108":"九畹溪镇","420527201":"水田坝乡","420527202":"泄滩乡","420527203":"梅家河乡","420527204":"磨坪乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420527.json
// module id = 1583
// module chunks = 0